import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useState, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollWindowRefContext = /*#__PURE__*/createContext({
  element: null,
  setElement: () => {}
});
export const ProvideScrollWindowRef = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [scrollElement, setScrollElement] = useState(null);
  let t1;
  if ($[0] !== scrollElement) {
    t1 = {
      element: scrollElement,
      setElement: setScrollElement
    };
    $[0] = scrollElement;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = /*#__PURE__*/_jsx(ScrollWindowRefContext.Provider, {
      value: value,
      children: children
    });
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useScrollWindowRef = () => {
  return useContext(ScrollWindowRefContext);
};